import { FC } from 'react';
import { Blank } from '@doda/io-react/common';
import style from './index.module.scss';

/**
 * Props
 * @param onClick 押下処理
 */
interface Props {
  onClick: () => void;
}

/** 詳細を見るボタン */
export const DetailButton: FC<Props> = ({ onClick }) => {
  return (
    <button
      type="button"
      className={style['detail-button__wrapper']}
      onClick={onClick}
    >
      <div className={style['detail-button__text']}>
        <span>詳細を見る</span>
        <Blank color="blue" size="XS" />
      </div>
    </button>
  );
};
